export const featuredProjects = [
  {
  "id": 1,
  "title": "Ovulation & Period Tracker Mobile App",
  "description": "A comprehensive mobile application designed to help users track their menstrual cycles, predict ovulation, and monitor fertility windows. The app features a predictive calendar, a statistical dashboard, detailed cycle history, and input logs for symptoms, mood, and flow intensity.",
  "role": "Lead UI/UX Designer & Developer",
  "challenge": "Designing a clean, simple, and intuitive interface for logging sensitive personal health data daily. Developing an accurate predictive algorithm for ovulation and future period dates based on user-inputted cycle patterns.",
  "solution": "Implemented a logic module to calculate cycle length, regularity, and predict upcoming fertile windows and period starts. Designed a clean, card-based UI for easy data entry and a clear dashboard to visualize 'Today's Phase', 'Upcoming Events', and 'Cycle Statistics'.",
  "techStack": ["UI/UX Design", "Figma", "React Native", "JavaScript (ES6+)", "Data Visualization"],
  "image": "/project/project3.1.jpeg",
  "images": [
    "/project/project3.2.jpeg",
    "/project/project3.3.jpeg",
    "/project/project3.4.jpeg",
    "/project/project3.5.jpeg"
  ],
  "liveUrl": "#",
  "githubUrl": "https://github.com/YourUsername/ovulation-tracker-app",
  "metrics": "Successfully designed and prototyped 5+ core app screens, tracking key health data points like cycle length, period length, and regularity."
}
,
  {
  id: 2,
  title: 'GameVault – Online Gaming Store & Library Platform',
  description: 'GameVault is a modern web platform designed to serve as a digital marketplace for video games. It allows users to browse, collect, and explore game titles with a smooth and visually engaging interface.',
  role: 'Full-Stack Developer',
  challenge: 'Creating a visually rich interface that handles large game assets while maintaining performance and accessibility across devices.',
  solution: 'Developed a fully responsive UI using HTML, CSS, JavaScript, and Bootstrap. Designed reusable product components and clean layout structures, enabling future integration of secure payments and backend APIs.',
  techStack: ['HTML', 'CSS', 'JavaScript', 'Bootstrap', 'Responsive UI/UX'],
  image: '/project/project1.1.png',
  images: [
    '/project/project1.2.png',
    '/project/project1.3.png',
    '/project/project1.4.png',
    '/project/project1.5.png'
  ],
  liveUrl: 'http://shehanchamika.me/GameVault/',
  githubUrl: 'https://github.com/Shehan2004-web/GameVault',
  metrics: '90%+ Lighthouse responsive UI score, 100+ structured product cards ready for scale'
  },
  {
  id: 3,
  title: 'SoftGen.lk – Full-Service Software Development & IT Solutions Platform',
  description: 'SoftGen.lk is a professional software company website that delivers enterprise-grade technology solutions, including Web Applications, Mobile Apps, Cloud Integrations, and Technical Consultancy. The platform improves business conversions by optimizing client acquisition, service showcasing, and customer engagement workflows.',
  role: 'Lead Full-Stack Developer & UI/UX Engineer',
  challenge: 'Designing a high-quality corporate platform with strong brand presence, SEO-focused content structure, and conversion-driven layouts to attract enterprise-level clients.',
  solution: 'Developed a modern, fully responsive web platform using HTML, CSS, Bootstrap, JavaScript, and PHP. Implemented SEO-optimized content architecture, fast-loading performance measures, and enhanced security practices to support strong corporate positioning and improved lead generation.',
  techStack: ['HTML', 'CSS', 'Bootstrap', 'JavaScript', 'PHP', 'SEO Optimization'],
  image: '/project/project2.1.png',
  images: [
    '/project/project2.2.png',
    '/project/project2.3.png',
    '/project/project2.4.png',
    '/project/project2.5.png'
  ],
  liveUrl: 'https://softgen.lk/',
  metrics: '40% increase in business inquiries within the first 3 months, 95+ Lighthouse performance and SEO scores'
},
  {
  id: 4,
  title: 'Food Delivery App – Online Food Ordering Platform',
  description: 'A modern food delivery application that enables users to browse restaurants, customize orders, track deliveries in real-time, and manage their food preferences. Features include menu browsing, cart management, secure checkout, order tracking, and user profile management.',
  role: 'Full-Stack Developer',
  challenge: 'Building a seamless ordering experience with real-time updates, managing complex order states, and ensuring smooth navigation across multiple restaurant menus while maintaining fast performance.',
  solution: 'Developed a responsive web application with intuitive UI/UX for browsing menus, adding items to cart, and completing orders. Implemented state management for cart operations, real-time order status updates, and integrated secure payment workflows.',
  techStack: ['React', 'JavaScript', 'HTML', 'CSS', 'Responsive Design', 'State Management'],
  image: '/project/project4.2.png',
  images: [
    '/project/project4.1.png',
    '/project/project4.3.png',
    '/project/project4.4.png',
    '/project/project4.5.png'
  ],
  liveUrl: 'https://github.com/Shehan2004-web/FoodDeliveryApp',
  githubUrl: 'https://github.com/Shehan2004-web/FoodDeliveryApp',
  metrics: 'Fully functional ordering system with cart management, order tracking, and user-friendly interface optimized for mobile and desktop'
}

]

export const otherProjects = [
  {
    id: 5,
    title: 'Portfolio Builder SaaS',
    description: 'A drag-and-drop portfolio builder for creatives with 50+ templates and custom domain support.',
    techStack: ['React', 'Firebase', 'Stripe'],
    category: 'SaaS',
    liveUrl: 'https://example.com',
    githubUrl: 'https://github.com/Shehan2004-web/portfolio-builder',
  },
  {
    id: 6,
    title: 'AI Content Generator',
    description: 'GPT-powered content generation tool for blog posts, social media, and marketing copy.',
    techStack: ['Next.js', 'OpenAI API', 'Tailwind'],
    category: 'AI/ML',
    liveUrl: 'https://example.com',
    githubUrl: 'https://github.com/Shehan2004-web/ai-content-generator',
  },
  {
    id: 7,
    title: 'Cryptocurrency Tracker',
    description: 'Real-time cryptocurrency price tracker with portfolio management and alerts.',
    techStack: ['React', 'CoinGecko API', 'Chart.js'],
    category: 'FinTech',
    liveUrl: 'https://example.com',
    githubUrl: 'https://github.com/Shehan2004-web/crypto-tracker',
  },
  {
    id: 8,
    title: 'Social Media Analytics Dashboard',
    description: 'Comprehensive analytics dashboard for tracking social media performance across platforms.',
    techStack: ['Vue.js', 'D3.js', 'Express'],
    category: 'Analytics',
    githubUrl: 'https://github.com/Shehan2004-web/social-analytics',
  },
  {
    id: 9,
    title: 'Fitness Tracking App',
    description: 'Mobile-first fitness app with workout plans, progress tracking, and nutrition logging.',
    techStack: ['React Native', 'Firebase', 'Redux'],
    category: 'Mobile',
    liveUrl: 'https://example.com',
    githubUrl: 'https://github.com/Shehan2004-web/fitness-tracker',
  },
  {
    id: 10,
    title: 'Weather Forecast PWA',
    description: 'Progressive web app providing accurate weather forecasts with offline support.',
    techStack: ['React', 'PWA', 'OpenWeather API'],
    category: 'PWA',
    liveUrl: 'https://example.com',
    githubUrl: 'https://github.com/Shehan2004-web/weather-pwa',
  },
]